import React from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

const services = [
  "Residential Cleaning",
  "Commercial Cleaning",
  "Deep Cleaning",
  "Pest Control",
  "Hygiene & Sanitation",
];

export const Footer: React.FC = () => {
  const whatsappLink = "https://wa.me/27679376048";
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-gradient text-on-primary full-width bottom shadow-md">
      <div className="max-w-container-max mx-auto px-md sm:px-lg py-lg sm:py-xl">
        <div className="bg-white/10 backdrop-blur-sm rounded-[1.5rem] sm:rounded-[2rem] border border-white/15 overflow-hidden">
          <div className="px-md py-lg sm:px-lg md:px-xl md:py-xl border-b border-white/10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-lg sm:gap-md">
            <div className="max-w-2xl text-center lg:text-left">
              <p className="text-xs uppercase tracking-[0.35em] text-white/75 font-bold mb-2">
                Ready for a spotless space?
              </p>
              <h2 className="font-headline-lg text-[clamp(1.8rem,5vw,2rem)] leading-tight text-white mb-sm">
                Professional cleaning and pest control for homes and businesses.
              </h2>
              <p className="text-white/80 font-body-md max-w-xl mx-auto lg:mx-0">
                Get dependable service, clear communication, and tailored
                solutions from a team across South Africa that values quality
                and reliability.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-sm shrink-0 w-full lg:w-auto">
              <a
                className="inline-flex w-full sm:w-auto items-center justify-center gap-sm rounded-full bg-white px-lg py-md font-bold text-primary hover:brightness-95 transition-all"
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                Request a Quote
                <span className="material-symbols-outlined text-[18px]">
                  arrow_forward
                </span>
              </a>
              <div className="flex flex-col gap-sm w-full sm:w-auto">
                <a
                  className="inline-flex w-full items-center justify-center gap-sm rounded-full border border-white/30 px-lg py-md font-bold text-white hover:bg-white/10 transition-all"
                  href="tel:+27679376048"
                >
                  <span className="material-symbols-outlined text-[18px]">
                    call
                  </span>
                  Call Now
                </a>
                <a
                  className="inline-flex w-full items-center justify-center gap-sm rounded-full border border-white/30 px-lg py-md font-bold text-white hover:bg-white/10 transition-all"
                  href="tel:0781668330"
                >
                  <span className="material-symbols-outlined text-[18px]">
                    call
                  </span>
                  078 166 8330
                </a>
              </div>
            </div>
          </div>

          <div className="px-md py-lg sm:px-lg md:px-xl sm:py-xl grid gap-lg sm:gap-xl sm:grid-cols-2 xl:grid-cols-[1.2fr_0.8fr_0.8fr_1fr]">
            <div className="space-y-md text-center sm:text-left sm:col-span-2 xl:col-span-1">
              <BrandLogo imageClassName="h-10 sm:h-12 w-auto mx-auto sm:mx-0" />
              <p className="text-white/80 font-body-md max-w-sm mx-auto sm:mx-0">
                Kolomaka Cleaning Services provides reliable cleaning, hygiene,
                sanitation, and pest control solutions across South Africa.
              </p>
              <div className="flex justify-center sm:justify-start gap-sm">
                <a
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                  href="https://www.instagram.com/kolomaka_?igsh=MTNqdjhmNzNhcXRsZw=="
                  aria-label="Instagram"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    className="w-5 h-5 text-white"
                    fill="currentColor"
                  >
                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5ZM12 6.75A5.25 5.25 0 1 1 6.75 12 5.26 5.26 0 0 1 12 6.75Zm0 1.5A3.75 3.75 0 1 0 15.75 12 3.75 3.75 0 0 0 12 8.25Zm5.5-.9a1.1 1.1 0 1 1-1.1-1.1 1.1 1.1 0 0 1 1.1 1.1Z" />
                  </svg>
                </a>
              </div>
            </div>

            <div className="text-center sm:text-left">
              <h3 className="font-headline-md text-headline-md text-white mb-md">
                Quick Links
              </h3>
              <div className="flex flex-col gap-sm items-center sm:items-start">
                {quickLinks.map((link) => (
                  <Link
                    key={link.label}
                    className="text-white/80 hover:text-white transition-colors"
                    to={link.to}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div className="text-center sm:text-left">
              <h3 className="font-headline-md text-headline-md text-white mb-md">
                Our Services
              </h3>
              <div className="flex flex-col gap-sm items-center sm:items-start">
                {services.map((service) => (
                  <span key={service} className="text-white/80">
                    {service}
                  </span>
                ))}
              </div>
            </div>

            <div className="text-center sm:text-left sm:col-span-2 xl:col-span-1">
              <h3 className="font-headline-md text-headline-md text-white mb-md">
                Contact Info
              </h3>
              <div className="space-y-sm text-white/80 max-w-sm mx-auto sm:mx-0">
                <p>South Africa</p>
                <div className="flex flex-col gap-1">
                  <a
                    className="block hover:text-white transition-colors"
                    href="tel:+27679376048"
                  >
                    +27 67 937 6048
                  </a>
                  <a
                    className="block hover:text-white transition-colors"
                    href="tel:0781668330"
                  >
                    078 166 8330
                  </a>
                </div>
                <a
                  className="block hover:text-white transition-colors break-words sm:break-normal"
                  href="mailto:kolomaakacleaning@gmail.com"
                >
                  kolomaakacleaning@gmail.com
                </a>
                <p>Mon-Fri: 8:00 AM - 6:00 PM</p>
                <p>Sat-Sun: 9:00 AM - 4:00 PM</p>
              </div>
            </div>
          </div>

          <div className="px-md py-md sm:px-lg md:px-xl border-t border-white/10 flex flex-col md:flex-row gap-sm md:items-center md:justify-between text-white/70 text-sm text-center md:text-left">
            <p>
              © {currentYear} Kolomaka Cleaning Services. All rights reserved.
            </p>
            <p>Clean is within our name.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
